export  const asideBarList = [
  //0普通医生
  [
    {
      name:'首页',
      url:'/home',
      icon:'iconfont icon-shouye'
    },
    {
      name:'病例管理',
      url:'/case_management',
      icon:'iconfont icon-bingliguanli'
    },
    {
      name:'会诊室',
      url:'/consultation_room',
      icon:'iconfont icon-huizhenshi'
    },
    {
      name:'耗材商城',
      url:'/consumables',
      icon:'iconfont icon-haocaiku'
    },
    {
      name:'订单中心',
      url:'/bill_center',
      icon:'iconfont icon-dingdanzhongxin'
    },
  ],
  //1导师
  [
    {
      name:'首页',
      url:'/home',
      icon:'iconfont icon-shouye'
    },
    {
      name:'病例管理',
      url:'/case_management',
      icon:'iconfont icon-bingliguanli'
    },
    {
      name:'医生列表',
      url:'/doctor',
      icon:'iconfont icon-yishengliebiao'
    },
    {
      name:'会诊室',
      url:'/consultation_room',
      icon:'iconfont icon-huizhenshi'
    },
    {
      name:'耗材商城',
      url:'/consumables',
      icon:'iconfont icon-haocaiku'
    },
    {
      name:'订单中心',
      url:'/bill_center',
      icon:'iconfont icon-dingdanzhongxin'
    },
    {
      name:'百宝箱',
      url:'/box',
      icon:'iconfont icon-baibaoxiang'
    },
  ],
  //业务员2
  [
    {
      name:'首页',
      url:'/sales_home',
      icon:'iconfont icon-shouye'
    },
    {
      name:'我的客户',
      url:'/sales_custom',
      icon:'el-icon-s-custom'
    },
    {
      name:'耗材商城',
      url:'/consumables',
      icon:'iconfont icon-haocaiku'
    },
    {
      name:'会诊室',
      url:'/consultation_room',
      icon:'iconfont icon-huizhenshi'
    },
    {
      name:'我的数据',
      url:'/sales_data',
      icon:'el-icon-s-data'
    },
    {
      name:'百宝箱',
      url:'/box',
      icon:'iconfont icon-baibaoxiang'
    },
  ],
  //客服3
  [
    {
      name:'首页',
      url:'/customer_home',
      icon:'iconfont icon-shouye'
    },
    {
      name:'病例咨询',
      url:'/case_consult',
      icon:'el-icon-chat-dot-square'
    },
    {
      name:'会诊室',
      url:'/consultation_room',
      icon:'iconfont icon-huizhenshi'
    },
    {
      name:'耗材商城',
      url:'/consumables',
      icon:'iconfont icon-haocaiku'
    },
    {
      name:'订单中心',
      url:'/bill_center',
      icon:'iconfont icon-dingdanzhongxin'
    },
    {
      name:'百宝箱',
      url:'/box',
      icon:'iconfont icon-baibaoxiang'
    },
    {
      name:'通知中心',
      url:'/notice_center',
      icon:'el-icon-mic'
    },
  ],
  //技师4
  [
    {
      name:'首页',
      url:'/technician_home',
      icon:'iconfont icon-shouye'
    },
    {
      name:'医生列表',
      url:'/doctor',
      icon:'iconfont icon-yishengliebiao'
    },
    {
      name:'会诊室',
      url:'/consultation_room',
      icon:'iconfont icon-huizhenshi'
    },
    {
      name:'耗材商城',
      url:'/consumables',
      icon:'iconfont icon-haocaiku'
    },
    {
      name:'订单中心',
      url:'/bill_center',
      icon:'iconfont icon-dingdanzhongxin'
    },
    {
      name:'百宝箱',
      url:'/box',
      icon:'iconfont icon-baibaoxiang'
    },
  ],
  //供应商5
  [
    {
      name:'首页',
      url:'/supplier_home',
      icon:'iconfont icon-shouye'
    },
    {
      name:'订单中心',
      url:'/bill_center',
      icon:'iconfont icon-dingdanzhongxin'
    }
  ],
]
